import React from 'react';
import Masonry from './Masonry';
import Card from './Card';
import { Grid } from '@material-ui/core';

const Universities = (props) => {
  return (
    <Grid container spacing={3}>
      {props.universities?.map((university, index) => (
        <Grid item sm={12} md={6}>
          <Card
            readOnly={props.readOnly}
            key={index}
            student={props.student}
            data={university}
            onEdit={props.onEdit}
            onViewLogs={props.onViewLogs}
            onDelete={props.onDelete}
            onAddDocument={props.onAddDocument}
            onUpdateDoc={props.onUpdateDoc}
            hasCCCredit={props.hasCCCredit}
            hasHCCredit={props.hasHCCredit}
            hasExpertCredit={props.hasExpertCredit}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default Universities;
